import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const POST_AUTH_REDIRECT_KEY = 'postAuthRedirectPath';

const SignUp = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const getPostAuthRedirect = () => {
      const fallbackPath = '/store';
      try {
        const returnTo = searchParams.get('returnTo');
        if (returnTo && returnTo.startsWith('/')) return returnTo;

        const saved = sessionStorage.getItem(POST_AUTH_REDIRECT_KEY);
        sessionStorage.removeItem(POST_AUTH_REDIRECT_KEY);
        if (saved && saved.startsWith('/')) return saved;
      } catch (e) {}
      return fallbackPath;
    };

    // Check if returning from Google OAuth
    const token = searchParams.get('token');
    const userParam = searchParams.get('user');

    if (token && userParam) {
      const userData = JSON.parse(decodeURIComponent(userParam));
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(userData));
      setUser(userData);
      // session stored in localStorage (no context)
      // Redirect based on role
      if (userData.role === 'admin') {
        navigate('/admin');
      } else {
        navigate(getPostAuthRedirect());
      }
      return;
    }

    // Check existing session
    const storedUser = localStorage.getItem('user');
    const storedToken = localStorage.getItem('token');
    if (storedUser && storedToken) {
      setUser(JSON.parse(storedUser));
    }
  }, [searchParams, navigate]);
  

  if (user) {
    return (
      <div style={{ minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem', background: '#f5f5f5' }}>
        <h1 className='text-5xl font-bdogrotesk font-medium m-auto'>Hey Welcome to Nufab!!</h1>
      </div>
    );
  }

  console.log('SignUp component rendered');

  return (
    <div style={{ minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem', background: '#f5f5f5' }}>
      <h1 className='text-5xl m-auto'>Hey Welcome to Nufab!!</h1>
    </div>
  );
};

export default SignUp;
